const safetyPage = () => import('@/pages/safetyPage/index')
const safetyDetail = () => import('@/pages/safetyPage/safetyDetail')
export default [{
  path: '/safetyDetail',
  name: '/safetyDetail',
  component: safetyDetail,
  meta: {}
},
{
  path: '/safetyPage',
  name: 'safetyPage',
  component: safetyPage,
  meta: {
    storeKey: 'trs.safetyPage.index'// 储存的key 等于undefined则不验证
  }
}
]



// WEBPACK FOOTER //
// ./src/router/safety/index.js